/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import RCTooltip from 'rc-tooltip';
import { hypernovaWrapperClassName } from '../../css/hypernova';

let tooltips = [];

export function hideAll() {
  tooltips.map(t => t.hide());
}

export function showSingleTooltip() {
  tooltips.map(t => t.show());
}

class Tooltip extends React.Component {
  constructor(props) {
    super();
    this.onVisibleChange = this.onVisibleChange.bind(this);
    this.state = { visible: props.defaultVisible };
  }

  componentDidMount() {
    tooltips.push(this);
    if (this.props.delayHide) {
      setTimeout(() => {
        this.hide();
      }, this.props.delayHide);
    }
  }

  componentWillUnmount() {
    tooltips = tooltips.filter(t => (t !== this));
  }

  onVisibleChange(visible) {
    hideAll();
    this.setState({
      visible,
    });
    if (visible) {
      const contentProps = this.props.content.props;
      if (contentProps && contentProps.onShow) {
        contentProps.onShow();
      }
    }
  }

  hide() {
    this.setState({ visible: false });
  }

  show() {
    this.setState({ visible: true });
  }

  render() {
    const { content, children, event, align, customClassName, destroyTooltipOnHide } = this.props;
    return (
      <RCTooltip
        getPopupContainer={() => {
          const id = 'hpernova-class-wrapper';
          const hpernovaClassWrapper = document.getElementById(id);
          if (hpernovaClassWrapper) {
            return hpernovaClassWrapper;
          }
          const elemDiv = document.createElement('div');
          elemDiv.classList.add(hypernovaWrapperClassName);
          elemDiv.id = id;
          document.body.appendChild(elemDiv);
          return elemDiv;
        }}
        overlay={content}
        trigger={[event]}
        visible={this.state.visible}
        mouseEnterDelay={0.2}
        mouseLeaveDelay={0.1}
        onVisibleChange={this.onVisibleChange}
        overlayStyle={{ opacity: '100' }}
        placement={this.props.placement}
        align={align}
        defaultVisible
        overlayClassName={customClassName}
        destroyTooltipOnHide={destroyTooltipOnHide}
      >
        { children }
      </RCTooltip>
    );
  }
}

Tooltip.propTypes = {
  content: PropTypes.oneOfType(
    [PropTypes.element, PropTypes.object, PropTypes.string, PropTypes.func],
  ).isRequired,
  children: PropTypes.element.isRequired,
  event: PropTypes.string,
  align: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
      PropTypes.bool,
    ]),
  ),
  placement: PropTypes.string,
  defaultVisible: PropTypes.bool,
  delayHide: PropTypes.number,
  customClassName: PropTypes.string,
  destroyTooltipOnHide: PropTypes.bool,
};

Tooltip.defaultProps = {
  event: '',
  defaultVisible: false,
  delayHide: 0,
  customClassName: '',
  placement: 'bottom',
  align: { points: ['tc', 'bc'], overflow: { adjustX: 0, adjustY: 0 }, targetOffset: [0, 0], useCssRight: false },
  destroyTooltipOnHide: false,
};

export default Tooltip;
